import { domainMeta } from './domainMeta';
import { type Environment } from './environments';

const POSTHOG_ENVIRONMENTS: Record<Environment, string> = {
  prod: 'production',
  // uat is pre-production traffic, so it folds into staging and stays out of
  // production dashboards.
  stage: 'staging',
  uat: 'staging',
  dev: 'development',
};

/**
 * The shared cross-app `environment` value (production | staging |
 * development). Every environment sends to one PostHog project, so this
 * property is what keeps staging and laptops out of product numbers. wx-ui and
 * Hire's server events use the same vocabulary.
 */
export const posthogEnvironment = POSTHOG_ENVIRONMENTS[domainMeta.environment];
